import { KPIFilters, ReportAnswerKPI } from '../../utils/reportKPI';

export const FETCH_KPI_DATA_REQUEST = 'FETCH_KPI_DATA_REQUEST';
export const FETCH_KPI_DATA_SUCCESS = 'FETCH_KPI_DATA_SUCCESS';
export const FETCH_KPI_DATA_FAILURE = 'FETCH_KPI_DATA_FAILURE';

export const FETCH_KPI_CHART_DATA_REQUEST = 'FETCH_KPI_CHART_DATA_REQUEST';
export const FETCH_KPI_CHART_DATA_SUCCESS = 'FETCH_KPI_CHART_DATA_SUCCESS';
export const FETCH_KPI_CHART_DATA_FAILURE = 'FETCH_KPI_CHART_DATA_FAILURE';

export const fetchKPIDataRequest = (filters: KPIFilters) => ({
  type: FETCH_KPI_DATA_REQUEST as typeof FETCH_KPI_DATA_REQUEST,
  payload: { filters },
});

export const fetchKPIDataSuccess = (answers: ReportAnswerKPI[], statuses: any[]) => ({
  type: FETCH_KPI_DATA_SUCCESS as typeof FETCH_KPI_DATA_SUCCESS,
  payload: { answers, statuses },
});

export const fetchKPIDataFailure = (error: string) => ({
  type: FETCH_KPI_DATA_FAILURE as typeof FETCH_KPI_DATA_FAILURE,
  payload: { error },
});

export const fetchKPIChartDataRequest = (filters: KPIFilters) => ({
  type: FETCH_KPI_CHART_DATA_REQUEST as typeof FETCH_KPI_CHART_DATA_REQUEST,
  payload: { filters },
});

export const fetchKPIChartDataSuccess = (kpiPlan: any[], kpiFact: any[]) => ({
  type: FETCH_KPI_CHART_DATA_SUCCESS as typeof FETCH_KPI_CHART_DATA_SUCCESS,
  payload: { kpiPlan, kpiFact },
});

export const fetchKPIChartDataFailure = (error: string) => ({
  type: FETCH_KPI_CHART_DATA_FAILURE as typeof FETCH_KPI_CHART_DATA_FAILURE,
  payload: { error },
});

export type FetchKPIDataRequestAction = ReturnType<typeof fetchKPIDataRequest>;
export type FetchKPIDataSuccessAction = ReturnType<typeof fetchKPIDataSuccess>;
export type FetchKPIDataFailureAction = ReturnType<typeof fetchKPIDataFailure>;

export type FetchKPIChartDataRequestAction = ReturnType<typeof fetchKPIChartDataRequest>;
export type FetchKPIChartDataSuccessAction = ReturnType<typeof fetchKPIChartDataSuccess>;
export type FetchKPIChartDataFailureAction = ReturnType<typeof fetchKPIChartDataFailure>;

export type KPIActionTypes =
  | FetchKPIDataRequestAction
  | FetchKPIDataSuccessAction
  | FetchKPIDataFailureAction
  | FetchKPIChartDataRequestAction
  | FetchKPIChartDataSuccessAction
  | FetchKPIChartDataFailureAction;
